<script lang="ts" setup>
import type { IDrawerHtmlContainerProps } from '../types'
import { mountCustomComponent } from '@/cms-ui/utils/mountCustomComponent'

const props = defineProps<IDrawerHtmlContainerProps>()

const htmlComponent = mountCustomComponent(props.componentName)
</script>

<template>
    <html-component
        v-if="htmlComponent"
        :component-name="componentName"
    />
    <section
        v-else
        v-html-gpp="html"
    />
</template>
